import React, { useState, useEffect } from 'react';
import HDImpactCards from './HDImpactCards';
import './HDImpactDashboard.css';
import HDImpactSidebar from './HDImpactSidebar';
import HDImpactMap from './HDImpactMap';
import HDImpactRightSidebar from './HDImpactRightSidebar';
import { HDImpactButtonContainer } from './HDImpactButton';
import HDImpactMapTable from './HDImpactMapTable';

const HDImpactDashboard = () => {
  const [selectedGender, setSelectedGender] = useState([]);
const [selectedAgeRange, setSelectedAgeRange] = useState([]);
const [selectedProjectName, setSelectedProjectName] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState({ start: null, end: null }); // NEW
  const [lastUpdated, setLastUpdated] = useState(null);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [selectedHomeState, setSelectedHomeState] = useState([]);
const [selectedHomeDistrict, setSelectedHomeDistrict] = useState([]);
const [selectedOperatingState, setSelectedOperatingState] = useState([]);
const [selectedOperatingDistrict, setSelectedOperatingDistrict] = useState([]);
  // Fetch last updated time
  useEffect(() => {
    const fetchLastUpdated = async () => {
      try {
        const response = await fetch('/db2_date&time.json');
        const data = await response.json();
        setLastUpdated(new Date(data.updatedAt).toLocaleString());
      } catch (error) {
        console.error('Error fetching last updated time:', error);
      }
    };

    fetchLastUpdated();
  }, []);

  return (
    <div className="hdimpact-main-content">
      <HDImpactCards />
      <div className="hdimpact-dashboard">
      <HDImpactSidebar
  onGenderChange={setSelectedGender}
  onAgeRangeChange={setSelectedAgeRange}
  onStateChange={setSelectedHomeState}
  onDistrictChange={setSelectedHomeDistrict}
  onOperatingStateChange={setSelectedOperatingState}
  onOperatingDistrictChange={setSelectedOperatingDistrict}
  onProjectNameChange={setSelectedProjectName}
/>
        <div className="hdimpact-map-container">
          <HDImpactButtonContainer />
          <HDImpactMap
            selectedGender={selectedGender}
            selectedAgeRange={selectedAgeRange}
            selectedProjectName={selectedProjectName}
            selectedDateRange={selectedDateRange}

            // 🔥 CRITICAL FIX
            selectedHomeState={selectedHomeState}
            selectedHomeDistrict={selectedHomeDistrict}
            selectedOperatingState={selectedOperatingState}
            selectedOperatingDistrict={selectedOperatingDistrict}
          />
        </div>
        <div className="hdimpact-right-sidebar">
          {/* {lastUpdated && (
            <div className="last-updated">
              <p>Last updated: {lastUpdated}</p>
            </div>
          )} */}
         <HDImpactRightSidebar
  selectedGender={selectedGender}
  selectedAgeRange={selectedAgeRange}
  selectedProjectName={selectedProjectName}
  selectedState={selectedState}
  selectedDistrict={selectedDistrict}

  // ✅ ADD THESE
  selectedHomeState={selectedHomeState}
  selectedHomeDistrict={selectedHomeDistrict}
  selectedOperatingState={selectedOperatingState}
  selectedOperatingDistrict={selectedOperatingDistrict}
/>
        </div>
      </div>
      <HDImpactMapTable
  selectedGender={selectedGender}
  selectedAgeRange={selectedAgeRange}
  selectedProjectName={selectedProjectName}
  selectedState={selectedState}
  selectedDistrict={selectedDistrict}
  selectedDateRange={selectedDateRange}   // ✅ ADD THIS
  selectedHomeState={selectedHomeState}
  selectedHomeDistrict={selectedHomeDistrict}
  selectedOperatingState={selectedOperatingState}
  selectedOperatingDistrict={selectedOperatingDistrict}
/>
    </div>
  );
};

export default HDImpactDashboard;
